import { useRef } from 'react';
import { useSelector } from 'react-redux'
import { useParams, Link } from 'react-router-dom'

import SearchBox from '../components/psc/lib/SearchBox'
import SelectFilterAttributeMulti from '../components/psc/lib/SelectFilterAttributeMulti'
import GncDataTable from '../components/psc/lib/GncDataTable'
import Loading from '../components/psc/lib/Loading'

import useAuthentication from '../hooks/useAuthentication';
import useUserManagement from '../hooks/useUserManagement';
import useTableSlots from '../hooks/useTableSlots';
import useProjectContents from '../hooks/useProjectContents';
import useBrowserTabTitle from '../hooks/useBrowserTabTitle';

const ActionItemSources = () => {
    const { projectID } = useParams()
    
    const pscState = useSelector(state => state.pscState.value)
    const project = pscState.project
    const isLoading = pscState.isLoading

    const { currentUser } = useAuthentication();
    useBrowserTabTitle(`${project.project_code} Meetings`)

    const table = useRef(null)
    const localStorageOrderKey = 'tblActionItemSourcesOrder'
    const defaultOrder = [[ 0, 'asc' ]]

    const {
        userHasProjectAccessLevel
    } = useUserManagement()

    const {
        isActionItemSourcesLoaded,
        actionItemSources,
    } = useProjectContents()
    
    const {
        dateSlot,
        filePathSlot,
        linkSlot,
        ownerSlot
    } = useTableSlots()

    const columns = [
        { data: 'source_date' },
        { data: 'name' },
        { data: 'default_item_type' },
        { data: 'location' },
        { data: 'action_count_total' },
        { data: 'action_count_open' },
        { data: 'action_count_closed' }
    ]

    const tableHead = (
        <tr>
            <th style={{width: '100px'}}>Date</th>
            <th>Name</th>
            <th style={{width: '60px'}} title="Internal / External">I/E</th>
            <th>Location</th>
            <th style={{width: '70px'}}>Actions</th>
            <th style={{width: '70px'}}>Open</th>
            <th style={{width: '70px'}}>Closed</th>
        </tr>
    )

    const tableSlots = {
        0: dateSlot,
        1: (data, type, row) => linkSlot(data, type, row, `/portfolio/${row.project_id}/action_item_sources/${row.id}`),
        2: (data, type, row) => {
            if (type === 'filter') return data
            if (data === 'External') return (<div style={{textAlign: 'center'}} title="External">E</div>)
            if (data === 'Internal') return (<div style={{textAlign: 'center'}} title="Internal">I</div>)
            return data
        },
        4: (data, type, row) => linkSlot(data, type, row, `/portfolio/${row.project_id}/action_items?source=${row.name}`),
        5: (data, type, row) => linkSlot(data, type, row, `/portfolio/${row.project_id}/action_items?source=${row.name}&status=Open`),
        6: (data, type, row) => linkSlot(data, type, row, `/portfolio/${row.project_id}/action_items?source=${row.name}&status=Closed`),
    }
    
    const type_filter = {
        code: 'type',
        name: 'Type',
        single_select_values: [
            {id: 2, value: 'External'},
            {id: 1, value: 'Internal'}
        ]
    }
    
    let actions
    if( project && userHasProjectAccessLevel(currentUser, project.id, 'MEMBER') ) {
        actions = (
            <div className="pre-table-buttons">
                <Link type="button" className="btn btn-mr btn-primary" to={`/portfolio/${projectID}/action_item_sources/new`}>New Meeting</Link>
                <Link to={`/portfolio/${projectID}/action_items`}>Manage Action Items</Link>
            </div>
        )
    }
    
    const showLoading = isLoading || !isActionItemSourcesLoaded
    
    return (
            <div className="wrapper wrapper-content">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-title">
                                <h2>Meetings</h2>

                                {actions}
                            </div>
                            <div className="ibox-content">
                                <div className="row">
                                    <SearchBox tableRef={table} />

                                    <SelectFilterAttributeMulti
                                        tableRef={table}
                                        attribute={type_filter}
                                        columnIndex="2"
                                        localStorageKey={`actionItemSourcesTypeFilterMulti_${projectID}`}
                                        placeholder="Select Meeting Type..."
                                    />
                                </div>

                                { showLoading ? <Loading /> : (
                                <GncDataTable
                                    tableRef={table}
                                    data={actionItemSources}
                                    defaultOrder={defaultOrder}
                                    localStorageOrderKey={localStorageOrderKey}
                                    columns={columns}
                                    tableSlots={tableSlots}
                                    tableHead={tableHead}
                                    tableFoot={tableHead}
                                />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
}

export default ActionItemSources
